<template lang="pug">
div.file-content
    //- <Button type="primary" @click="modal1 = true">我的文档</Button>
    Modal(v-model="modal1" @on-ok="ok" ok-text="知道啦" cancel-text="" width="860"  height="768" ,:mask-closable='false',:closable='false').file-title
      div.left-title
        ul
          template(v-for="(v,index) in stepName")
            li(@click="active = index;query();",v-if="index < willDoIndex",:class="{'active' : index === active}")  {{v}}
      div.right-content
          Spin(v-if="spinState" size="large" fix)
          h1.title-nav 我的文档
          div.tag#Anchor_props1 {{stepName[active]}}
            div.small(v-for='(v,index) in list',v-if='list.length!==0')
              p.y
              span.span {{v.departmentName}}
              //- div.stem {{v.essayQuestionTitle}}
              div.stem {{v.analysisQuestion}}
              div.stem 答：{{v.stuAnswer}}
            div.small(v-else) 无内容
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      modal1: true,
      stepName: ["政策制定", "政策执行", "政策评估", "政策终结"],
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      list: [],
      spinState: true,
      willDoIndex: +sessionStorage.getItem("willDoIndex")
    };
  },
  methods: {
    queryTest(value) {
      // console.log(JSON.parse(value));
      const departData = [];
      JSON.parse(value).forEach(item => {
        console.log(item);
        this.$http.getCaseDepartmentStepById({ id: item.department }).then(res => {
          console.log(res.data.data.departmentName);
          if (res.data.success === true) {
            departData.push(res.data.data.departmentName, item.content);
            console.log(departData);
          }
        });
      });
      return value;
    },
    jump(selector) {
      console.log(this);
      const anchor = this.$el.querySelector(selector);
      document.body.scrollTop = anchor.offsetTop;
    },
    ok() {
      this.$emit("ok");
    },
    query() {
      this.list = [];
      const data = {
        userId: this.$role.code,
        experimentId: this.$store.state.doCase.experimentId,
        caseHallId: this.$store.state.doCase.caseData[this.step[this.active]].tsId,
        controlTypes: JSON.stringify([
          "ESSAYQUESTION ",
          "MATERIALANALYSISPROBLEM ",
          "QUESTIONNAIRESURVEY"
        ])
        // controlType: "SINGLECHOICE"
        // controlType: "ESSAYQUESTION"
      };
      this.$http.queryInvestigateMyDocument(data).then(res => {
        console.log(res);
        console.log(this);
        if (res.data.success) {
          res.data.data.forEach(res1 => {
            const data2 = res1;
            data2.HallName = res1.departmentName;
            this.list.push(data2);
          });
          this.spinState = false;
          // this.list.FORMULATE.forEach(item1 => {
          //   item1.questionAnswer1 = [];
          //   JSON.parse(item1.questionAnswer).forEach(item => {
          //     this.$http.getCaseDepartmentStepById({ id: item.department }).then(res2 => {
          //       if (res2.data.success === true) {
          //         item1.questionAnswer1.push(res2.data.data.departmentName, item.content);
          //       }
          //     });
          //   });
          // });
          this.$forceUpdate();
        } else {
          this.spinState = false;
        }
        // -
      });
    }
  },
  created() {
    this.query();
    console.sun(this.$store.state.doCase.caseData[this.step[this.active]]);
  }
};
</script>
<style lang="stylus" scoped>
.ivu-modal-wrap *
  .ivu-modal-content
    .ivu-modal-body
      .left-title
        display inline-block
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        width 195px
        float left
        ul
          display flex
          flex-direction column
          li
            cursor pointer
            height 40px
            line-height 40px
            padding-left 32px
          .active
            background rgba(234, 244, 255, 1)
            border-right 2px solid #4A90E2
      .right-content
        width 610px
        height 630px
        display inline-block
        border-left 2px solid #EEF2F5
        padding 0 28px
        position: relative;
        .title-nav
          font-size 24px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(42, 46, 54, 0.8)
        .tag
          font-size 20px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(42, 46, 54, 0.8)
          margin-top 20px
          .span
            position relative
            font-size 16px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 1)
            line-height 20px
          .stem
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 0.75)
            line-height 24px
            word-wrap break-word
        .y
          border-bottom 1px solid #ddd
          position relative
          top 13px
          width 71%
          left 29%
        .small
          width 583px
          font-size 16px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 1)
          padding-top 19px
</style>
